import { useEffect } from "react";
import {
  Container,
  Card
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopProduct } from "../actions/shopActions";
import Loading from "./Loading";
import { RootState } from "../reducers";
import ProductButtonsBuy from "./ProductButtonsBuy";
import ProductCarousel from "./ProductCarousel";
import { useParams } from 'react-router-dom';

const Product = () => {
  const { productId }: any = useParams()
  const product = useSelector((state: RootState) => state.shop.product[productId])
  const pathImages = useSelector((state: RootState) => state.shop.pathImages[productId])
  const isLoading = useSelector((state: RootState) => state.shop.isLoading);
  const dispatch: any = useDispatch()

  useEffect(() => {
    dispatch(fetchShopProduct(productId));
  }, [productId, dispatch]);

  const style = {
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    color: "#000",
    textDecoration: "none",
  };

  return !isLoading && product ? (
    <Container>
      <h1 className="page-header">{product.name}</h1>
      <div className="row">
        <div className="col-lg-8 mb-2">
          {pathImages?.length > 0 && <ProductCarousel pathImages={pathImages} />}
        </div>
        <div className="col-lg-4">
          <Card
            className="card-outline-secondary text-center mb-2"
            style={style}
          >
            <Card.Body>
              <Card.Title>{product.name}</Card.Title>
              <Card.Title>{product.price_wholesale}</Card.Title>
              <Card.Text>{product.description}</Card.Text>
            </Card.Body>
            <Card.Footer className="bg-transparent">
              <ProductButtonsBuy productId={product.id} />
            </Card.Footer>
          </Card>
        </div>
      </div>
    </Container>
  ) : (
    <Loading />
  );
};

export default Product;
